import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var FindIllustration = function FindIllustration(_a) {
  var className = _a.className,
    _a$color = _a.color,
    color = _a$color === undefined ? 'sapphire' : _a$color,
    otherProps = __rest(_a, ["className", "color"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "FindIllustration",
    role: "img",
    viewBox: "0 0 112 72",
    xmlns: "http://www.w3.org/2000/svg",
    width: "112",
    height: "72",
    fill: "none",
    className: classNames('cogs-illustration', 'cogs-themed-icon', className)
  }, otherProps, {
    children: [jsx("path", {
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      d: "M20.067 60.085a3.124 3.124 0 0 1-4.418-4.419l10.088-10.088a20.54 20.54 0 0 1-4-12.213c0-11.394 9.237-20.632 20.631-20.632S63 21.972 63 33.366s-9.237 20.632-20.632 20.632a20.54 20.54 0 0 1-12.212-4z",
      opacity: ".3"
    }), jsx("path", {
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      d: "M63.556 52.11c11.352 0 20.554-9.203 20.554-20.555S74.908 11 63.556 11 43 20.203 43 31.555s9.203 20.554 20.555 20.554",
      opacity: ".3"
    }), jsx("path", {
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      fillRule: "evenodd",
      d: "M84.337 48.086a26.44 26.44 0 0 0 5.772-16.531C90.11 16.889 78.22 5 63.555 5 48.889 5 37 16.889 37 31.555c0 14.665 11.889 26.554 26.555 26.554a26.44 26.44 0 0 0 16.54-5.78l15.79 15.79a3 3 0 0 0 4.242-4.243zM63.555 52.11c11.352 0 20.554-9.202 20.554-20.554S74.907 11 63.555 11 43 20.203 43 31.555s9.203 20.554 20.555 20.554",
      clipRule: "evenodd",
      opacity: ".5"
    })]
  }));
};

export { FindIllustration };
